import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {useSolv} from "./components/SolvProvider";
import {useIntlEx} from "./components/IntlUtils";
import {MainContainer} from "./components/FormComps.js"
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("ConfirmEmailAddress")

export default function ConfirmEmailAddress(props) {

  const {api, setBusy, setFatal} = useSolv()
  const {intl } = useIntlEx()

  const params = useParams()

  const [alert, setAlert] = useState(null)

  useEffect(() => {
    if (params.magicCode) {
      updateSignin(params.magicCode)
    }
    else {
      window.location = "/signin"
    }
  }, [])

  function updateSignin(magicCode) {
    // log.debug("updateSignin: magicCode=", magicCode)
    setBusy(intl.msg("loading"))
    api.updateSignin(magicCode)
      .then(({data}) => {
        setAlert({type: "success", text: intl.msg("member_change_email_address_success_text")})
      })
      .catch((error) => {
        setAlert({type: "error", text: intl.msg("error_failed")})
      })
      .finally(() => {
        setBusy(null)
      })
  }

  return (
    <MainContainer>
    </MainContainer>
  )
}
